import { CATALOG_ROUTES, catalogueSnapshotOutput, exerciseDetailOutput, exerciseDetailPathWithQuery, exerciseListOutput, exerciseReportOutput, exerciseReportsPath, filtersOutput, toExerciseListQueryString, } from "@repo/contract/catalog";
import { readJson } from "../../api/auth-api";
import { getJson, sendJson, withQuery, } from "../core/request";
/**
 * The catalogue routes. Paths and query strings come from the contract's own
 * builders — `toExerciseListQueryString` omits undefined fields and encodes
 * the search term, `exerciseDetailPathWithQuery` encodes the id — so there is
 * one encoder, the contract's, and the server's decoder agrees with it.
 */
/** `GET /catalog/exercises` — one page. The search term goes as typed: the
 *  server folds it (`exerciseListQuery.q`), and folding here would be a second
 *  folding to keep in agreement. */
export function fetchExerciseList(api, query, init) {
    const path = `${CATALOG_ROUTES.exercises}${toExerciseListQueryString(query)}`;
    return getJson(api, path, exerciseListOutput, init);
}
/** `GET /catalog/exercises/:id` — one exercise in full. */
export function fetchExerciseDetail(api, id, locale, init) {
    return getJson(api, exerciseDetailPathWithQuery(id, locale), exerciseDetailOutput, init);
}
/** `GET /catalog/filters` — the filter vocabulary and its counts. */
export function fetchCatalogFilters(api, locale, init) {
    return getJson(api, withQuery(CATALOG_ROUTES.filters, { locale }), filtersOutput, init);
}
/**
 * `GET /catalog/snapshot` — the whole catalogue for the device (`D194`).
 * With the version the device holds, a catalogue that has not changed is a
 * 304 and no body: `unchanged`.
 */
export async function fetchCatalogueSnapshot(api, locale, held) {
    const response = await api.authorizedFetch(withQuery(CATALOG_ROUTES.snapshot, { locale }), {
        method: "GET",
        ...(held === undefined
            ? {}
            : { headers: { "if-none-match": `"${held}"` } }),
    });
    if (response.status === 304) {
        return { kind: "unchanged" };
    }
    return {
        kind: "fresh",
        snapshot: await readJson(response, catalogueSnapshotOutput),
    };
}
/**
 * `POST /catalog/exercises/:id/reports` — "Dados errados?" (`D199`).
 *
 * 201 for a new report and 200 for a resend of the same `input.id`; the body
 * is the stored report either way, so the caller has nothing to tell apart.
 * Mint `id` once per submission with the `uuidv7` helper and send the same one
 * on a retry, or the retry is a second report in the owner's count.
 */
export function reportExercise(api, exerciseId, input) {
    return sendJson(api, "POST", exerciseReportsPath(exerciseId), input, exerciseReportOutput);
}
//# sourceMappingURL=api.js.map